/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Regenerate_Think_LongerInputs */



/**
* | output |
* | --- |
* | "Think longer" |
*
* @param {Chat_Regenerate_Think_LongerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_regenerate_think_longer = /** @type {((inputs?: Chat_Regenerate_Think_LongerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Regenerate_Think_LongerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Länger nachdenken")
	return /** @type {LocalizedString} */ ("Think longer")
});